import { createServerFn } from '@tanstack/react-start';
import api from '../utils/api';
import { filterActiveDestination } from '../utils/photoUtils';

export const getDestination = createServerFn()
    .handler(async () => {
        const response = await api('get', 'destination-detail');
        return filterActiveDestination(response.data);
    });